import { useState, useEffect, Fragment, useRef } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";
import InputDate from "../../helpers/InputDate";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";
import ClientForm from "../home/ClientForm";
import ClientReview from "../home/ClientReview";


function Rn(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 
 


    const [filterParam, setFilterParam] = useState({   


        refresh: '0',
        
        nazwa:  props.mainView.readFilter('hh_nazwa',''),    
        nip:  props.mainView.readFilter('hh_nip',''),    
        archiwalny:  props.mainView.readFilter('hh_archiwalny','0'),    

        sl_typ_uslugi_id:  props.mainView.readFilter('hh_sl_typ_uslugi_id',''),    

        stan_umowy:  props.mainView.readFilter('hh_stan_umowy',''),    


        saldo_od:  props.mainView.readFilter('hh_saldo_od','-100000000'),   
        saldo_do:  props.mainView.readFilter('hh_saldo_do','-0.01'),   

        data_do:  props.mainView.readFilter('hh_data_do',''),   

        fak_opcja:  props.mainView.readFilter('hh_fak_opcja','_x_'),   

        data_fak_od:  props.mainView.readFilter('hh_data_fak_od',''),   
        data_fak_do:  props.mainView.readFilter('hh_data_fak_do',''),   

        kwota_fak_od:  props.mainView.readFilter('hh_kwota_fak_od',''),   
        kwota_fak_do:  props.mainView.readFilter('hh_kwota_fak_do',''),   
 

 
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([        
        {
            cls:'color_deleted',
            title: 'obciążenie',
             filter: {  filed: "strona", set: "wn", typ: "combo"  },
        }, {
            cls:'color_show2',
            title: 'uznanie',
             filter: {  filed: "strona", set: "ma", typ: "combo"  },
        },
    ]);




    const changeView = (e ) => {
                var v = e.target.getAttribute('v');
                var id = e.target.getAttribute('id');
                setView({...view, ["v"]:v, ["id"]:id });
        }



        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val  && 1==2)
            {
                    var defTimeOut = 5000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }



 


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

        

            props.mainView.writeFilter('hh_nazwa', ''); 
            props.mainView.writeFilter('hh_nip', '');
            props.mainView.writeFilter('hh_archiwalny', '0');
            props.mainView.writeFilter('hh_sl_typ_uslugi_id', '');

            props.mainView.writeFilter('hh_stan_umowy', '');

            props.mainView.writeFilter('hh_saldo_od', '-100000000');
            props.mainView.writeFilter('hh_saldo_do', '-0.01'); 

            props.mainView.writeFilter('data_fak_od', ''); 
            props.mainView.writeFilter('data_fak_do', ''); 

            props.mainView.writeFilter('hh_fak_opcja', '_x_'); 

            props.mainView.writeFilter('data_do', ''); 

            props.mainView.writeFilter('hh_kwota_fak_od', ''); 
            props.mainView.writeFilter('hh_kwota_fak_do', ''); 
          
           
            setFilterParam({
       
                refresh: '0',

                nazwa: '',                                        
                nip: '',                 
                archiwalny: '0', 
                sl_typ_uslugi_id: '', 

                saldo_od: '-100000000',                 
                saldo_do: '-0.01',                                                    
                data_do: '',      

                fak_opcja: '_x_',                                                    

                data_fak_od: '',                                                    
                data_fak_do: '',                                                    

                kwota_fak_od: '',                                                    
                kwota_fak_do: '',                                                    

                stan_umowy: '',                                                    
              
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




        
    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }


    const goRefresh = () => {
         
            filterParam.refresh = '1';
            getTab();
    }
  


    const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_rap,rp_n', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    filterParam.refresh = '0';
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }




    
     const getTServices = () => {
        
   
        props.mainView.showProgress();    

        fetch( Config.url + '/rest_v1_home,t_services', {
            method: 'POST', 
            body: JSON.stringify({all:1}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();    
                 

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setServices(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();    
         });
                   

         return false;
    }

 
 
  

    const keyListener = (e) => {


                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(  code == 27 && (view.v == "new") )  
                        {
                                setView({v:'list',id:-1});
                        }else                                                     
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                            e.target.blur();
                            filterClear();
                        }   else     
                        if(e.target.nodeName.toLowerCase() == "body" && code == 77 ) //m - ma
                        {
                            setFilterParam( {...filterParam,["strona"]:'ma' } );
                            setTab(null);
                        }   else       
                         if(e.target.nodeName.toLowerCase() == "body" && code == 87 ) //w - wn
                        {
                            setFilterParam( {...filterParam,["strona"]:'wn' } );
                            setTab(null);
                        }   else                
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                           filterClear();
                        } else                                                                                          
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                            setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        } else                                                                  
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                               props.keyListener(e);
                        }

    }


   useEffect( ()=>{

            if(Config.env == "dev") console.log("Rn.js, listener on");
            window.onkeydown = keyListener;   
                    
            
            return () => {   
                 if(Config.env == "dev") console.log("Rn.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );


    




    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        filterClear();
        getTServices();
        setTab(null);       
    }



    if(tab == null)
    {
        setTab([]);
        getTab();  
        getTServices();            
        return <div>
            ...
        </div>
    }

 
 
    var dialogBox = null;
    
        var sortList = [                                  
        {column: "saldo", name: "Saldo"  },                  
        {column: "firma_nazwa", name: "Nazwa firmy"  },
        {column: "data_ost_faktury", name: "Data ost. faktury"  },
    ]


    document.title = "Raport należności" ;


        
  
    

    var titleRaport = "Raport należności";

    

    if(filterParam.data_do.length > 2)
    {
         titleRaport +=", do dnia: " + filterParam.data_do;
    }




     if(view.v == "client")
            {
                return <ClientReview userData={props.userData} mainView={props.mainView} keyListener={keyListener}  onBack={onBack} onSuccess={onSuccess}  id={view.id}     />
            }



    return  <div className="view_content">


                 
               <h3 className="dash_header">Raport należności</h3>
                              

    
               <div className="table_filter">

                   
                
                        <div className="filter_controll">   
                                                <label>Klient: </label>                             
                                                <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                        </div> 
                                          

                         <div className="filter_controll">   
                                            <label>NIP: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.nip}   valChange={valChangeListener} goNext={goNextNew} name="nip" placeholder={"NIP: "}   />
                        </div>  


                        <div className="filter_controll">   
                                <label>Archiwalny: </label>                             
                                <InputCombo items={ [{v:'_x_',title:'- - - '}, {v:'0',title:'Nie'}, {v:'1',title:'Tak'},      ] }   userData={props.userData} value={filterParam.archiwalny}   valChange={valChangeListener} goNext={goNextNew} name="archiwalny" placeholder={": "}   />
                        </div> 


                        <div className="filter_controll">   
                                <label>Typ klienta: </label>                             
                                <InputCombo items={services}   userData={props.userData} value={filterParam.sl_typ_uslugi_id}   valChange={valChangeListener} goNext={goNextNew} name="sl_typ_uslugi_id" placeholder={": "}   />
                        </div> 

                        <div className="filter_controll">   
                                <label>Status umowy: </label>                             
                                <InputCombo items={ [{v:"_x_",title:'- - - '},{v:"1",title:'Aktywna'}, {v:"2",title:'Nieaktywna'}] }   userData={props.userData} value={filterParam.stan_umowy}   valChange={valChangeListener} goNext={goNextNew} name="stan_umowy" placeholder={": "}   />
                        </div> 

                        
                        <div className="filter_controll filter_merge">   
                            <label>Saldo (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.saldo_od}   valChange={valChangeListener} goNext={goNextNew} name="saldo_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.saldo_do}   valChange={valChangeListener} goNext={goNextNew} name="saldo_do" placeholder={" "}   />
                        </div>

                         <div className="filter_controll filter_merge">   
                            <label>Saldo do dnia: </label>        
                            <br/>                                                 
                            <InputDate   userData={props.userData}  mainView={props.mainView}  value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={" "}   />
                        </div>
  

                        <div className="filter_controll filter_merge">   
                            <label>Filtr ost. faktura: </label>        
                            <br/>                                                 
                            <InputCombo items={  [  { v: '_x_', title:'- - - '},{ v: '1', title:'W podanym okresie'}, { v: '2', title:'Poza podanym okresem'},     ]  }   userData={props.userData}  mainView={props.mainView}  value={filterParam.fak_opcja}   valChange={valChangeListener} goNext={goNextNew} name="fak_opcja" placeholder={" "}   />
                        </div>

                        <div className="filter_controll filter_merge">   
                            <label>Ostatnia faktura (od / do): </label>        
                            <br/>                                                 
                            <InputDate   userData={props.userData}  mainView={props.mainView}  value={filterParam.data_fak_od}   valChange={valChangeListener} goNext={goNextNew} name="data_fak_od" placeholder={" "}   />
                            <InputDate   userData={props.userData}  mainView={props.mainView}  value={filterParam.data_fak_do}   valChange={valChangeListener} goNext={goNextNew} name="data_fak_do" placeholder={" "}   />
                        </div>


                        
                        <div className="filter_controll filter_merge">   
                            <label>Kwota ost. faktury (od / do): </label>        
                            <br/>                                                 
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_fak_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_fak_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_fak_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_fak_do" placeholder={" "}   />
                        </div>


                      

                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                                                    
                                <span onClick={goRefresh} className="btn">Odśwież teraz (wg. filtrów)</span>

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  /> 
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />

                                    &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>

                <div className="tip">
                    Uwaga: Ten raport odświeża się z dokładnością do 1 dnia. Jeśli chcesz pobrać świeże informacje wybierz 'odśwież teraz'               
                </div>

                <br/>

               <div className="bg_center">


                  <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3>  

                                <table className="table" ref={tab2Ref} >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Klient</td>                                                                                                                                                                                              
                                                <td>NIP</td>    

                                                <td>Data ost. faktura</td>                                                                                                                                                                                              
                                                <td>Kw. ost. faktura</td>                                                                                                                                                                                              

                                                <td>Data ost. przelewu</td>                                                                                                                                                                                              
                                                <td>Kw. ost. przelewu</td>    

                                                <td>Saldo</td>  
                                                 <td>Saldo fak. (ponad rok)</td>                                                                                                                                                                                                                                   
                                                <td>Saldo fak. (do roku)</td>                                                                                                                                                                                                                                    
                                                <td className="td_right">Na dzień</td>                                                                                                   
                                                                                                        
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
  
                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="goleft"    >{row.klient.nazwa} </td>                                                              
                                                                <td className="gocenter"    >{row.klient.nip}</td>                                                              

                                                                <td className="gocenter"    >{row.faktura.data_ost_faktury}</td>                                                              
                                                                <td className="goright"    ><FormatDecimal value={row.faktura.kwota_ost_faktury} /> </td>                                                              

                                                                <td className="gocenter"    >{row.przelew.data_ost_przelewu}</td>                                                              
                                                                <td className="goright"    ><FormatDecimal value={row.przelew.kwota_ost_przelewu} /> </td>   

                                                                <td className="goright"    ><FormatDecimal value={row.saldo} /></td>                                                              

                                                                <td className="goright"    ><FormatDecimal value={row.ponad_rok} /></td>                                                              
                                                                <td className="goright"    ><FormatDecimal value={row.do_roku} /></td>    

                                                                <td className="gocenter"    >{row.saldo_na_dzien}</td>                                                              
                                                            </tr>

                                                    } )
                                                }

                                          

                                        </tbody>

                                </table>


                  </div>

                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Klient</td>                                                                                                                                                                                              
                                                <td>NIP</td>    

                                                <td>Data ost. faktura</td>                                                                                                                                                                                              
                                                <td>Kw. ost. faktura</td>                                                                                                                                                                                              

                                                <td>Data ost. przelewu</td>                                                                                                                                                                                              
                                                <td>Kw. ost. przelewu</td>    

                                                <td>Saldo</td>                                                                                                                                                                                                                                   
                                                <td>Saldo fak. (ponad rok)</td>                                                                                                                                                                                                                                   
                                                <td>Saldo fak. (do roku)</td>                                                                                                                                                                                                                                   
                                                <td className="td_right">Na dzień</td>                                                                                                   
                                                                                                        
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
  
                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="goleft"    >{row.klient.nazwa} <sup className="link_normal" onClick={changeView} v="client" id={row.klient.id}  > pokaż</sup> </td>                                                              
                                                                <td className="gocenter"    >{row.klient.nip}</td>                                                              

                                                                <td className="gocenter"    >{row.faktura.data_ost_faktury}</td>                                                              
                                                                <td className="goright"    ><FormatDecimal value={row.faktura.kwota_ost_faktury} /> </td>                                                              

                                                                <td className="gocenter"    >{row.przelew.data_ost_przelewu}</td>                                                              
                                                                <td className="goright"    ><FormatDecimal value={row.przelew.kwota_ost_przelewu} /> </td>   

                                                                <td className="goright"    ><FormatDecimal value={row.saldo} /></td>                                                              

                                                                <td className="goright"    ><FormatDecimal value={row.ponad_rok} /></td>                                                              
                                                                <td className="goright"    ><FormatDecimal value={row.do_roku} /></td>                                                              

                                                                <td className="gocenter"    >{row.saldo_na_dzien}</td>                                                              
                                                            </tr>

                                                    } )
                                                }

                                          

                                        </tbody>

                                </table>

               </div>
 
              

                              
           {dialogBox}

    </div>
}


export default Rn;